export const formatNumberFloat = (value: number, toFixed = 2): number => {
  return value % 1 !== 0 ? Number(value.toFixed(toFixed)) : value;
};
